"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  loadMessages: () => loadMessages,
  matchNotification: () => matchNotification
});
module.exports = __toCommonJS(utils_exports);
var import_communication_shared = require("@hcengineering/communication-shared");
async function loadMessages(client, cardId, blobId, params, options, cache) {
  const doc = await loadMessagesDoc(client, cardId, blobId, cache);
  if (doc === void 0) {
    return [];
  }
  return (0, import_communication_shared.parseMessagesDoc)(doc, params, options);
}
__name(loadMessages, "loadMessages");
async function requestMessagesDoc(client, cardId, blobId) {
  const res = await client.getJson(`${cardId}/messages/${blobId}`, {
    maxRetries: 3,
    isRetryable: /* @__PURE__ */ __name(() => true, "isRetryable"),
    delayStrategy: {
      getDelay: /* @__PURE__ */ __name(() => 500, "getDelay")
    }
  });
  if (res?.body === void 0) {
    return void 0;
  }
  return res.body;
}
__name(requestMessagesDoc, "requestMessagesDoc");
async function loadMessagesDoc(client, cardId, blobId, cache) {
  if (cache != null && cache.has(blobId)) {
    return await cache.get(blobId);
  }
  const messagesPromise = requestMessagesDoc(client, cardId, blobId);
  if (cache != null) {
    cache.set(blobId, messagesPromise);
  }
  return await messagesPromise;
}
__name(loadMessagesDoc, "loadMessagesDoc");
function matchNotification(notification, params) {
  if (params.type !== void 0 && params.type !== notification.type) return false;
  if (params.read !== void 0 && params.read !== notification.read) return false;
  if (params.id !== void 0 && params.id !== notification.id) return false;
  if (params.contextId !== void 0 && params.contextId !== notification.contextId) return false;
  if (params.cardId !== void 0 && params.cardId !== notification.cardId) return false;
  const created = notification.created.getTime();
  if (params.created != null) {
    if (params.created instanceof Date) {
      if (created !== params.created.getTime()) return false;
    } else {
      const { greater, less, greaterOrEqual, lessOrEqual } = params.created;
      if (greater != null && created <= greater.getTime()) return false;
      if (less != null && created >= less.getTime()) return false;
      if (greaterOrEqual != null && created < greaterOrEqual.getTime()) return false;
      if (lessOrEqual != null && created > lessOrEqual.getTime()) return false;
    }
  }
  return true;
}
__name(matchNotification, "matchNotification");
//# sourceMappingURL=utils.js.map
